import React from 'react'
import './HeroSection.css'

function HeroSection() {
    return (
        <>
            <div className="hero-container col">

                <video src="/videos/video-2.mp4" autoPlay loop muted />

            </div>

            <h1 className="text-center ">Parag Coimbatore</h1>

            <div class="dropdown mx-5 " style={{ margin: '4.1rem' }} >
            
                <a class="btn btn-primary dropdown-toggle mx-3" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                    Categories
                </a>

                <ul class="dropdown-menu " aria-labelledby="dropdownMenuLink">
                    
                    <button type="button" href={"http://localhost:3000/services"} class="btn btn-primary mx-2">Music</button>
                    <button type="button" class="btn btn-primary mx-2 mb-2">Politics</button>
                    <button type="button" class="btn btn-primary mx-2 mb-2">Travel</button>
                    <button type="button" class="btn btn-primary mx-2 mb-2">Romance</button>
                    <button type="button" class="btn btn-primary mx-2 mb-2">Career</button>
                    <button type="button" class="btn btn-primary mx-2 mb-2">Exams</button>
                    <button type="button" class="btn btn-primary mx-2 mb-2">Lifestyle</button>
                </ul>

                <a href={"http://localhost:3000/create"} className="btn btn-primary ">Create Blog</a>
            </div>


        </>
    )

}

export default HeroSection
